import { createAsyncThunk } from '@reduxjs/toolkit';
import { createRequest } from '../../../helpers/api/createRequest';
import * as faqApi from '../../../api/faq';
import { Thunk } from '../../../helpers/redux/Thunk';
import { addNotification } from '../../notifications/addNotification';
import { TypesSnackbars } from '../../../types/TypesSnackbars';
import { TypesIcon } from '../../../types/TypesIcon';
import { getFaqList } from './getFaqList';

export const DELETE_FAQ = 'faq/deleteFaq';

const onSuccess = (): Thunk => async (dispatch, getState) => {
    const { lastListParams } = getState().faq;

    if (lastListParams) {
        await dispatch(getFaqList(lastListParams));
    }

    dispatch(addNotification({
        type: TypesSnackbars.ERROR,
        message: {
            title: 'FAQ удалён',
            description: '',
        },
        icon: TypesIcon.SNACK_ERROR,
    }));
};

export const deleteFaq = createAsyncThunk(
    DELETE_FAQ,
    createRequest({
        type: DELETE_FAQ,
        loader: async (id: number) => faqApi.deleteFaq(id),
        onSuccess,
    }),
);
